import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import css from './ListingCard.module.css';
import classNames from 'classnames';
import { strToSlug } from '../../../util/seo';
import VerificationBadge from '../verification-badge/VerificationBadge';
import TierBadge from '../TierBadge/TierBadge';
import { readPublicBadgeTier, TIERS } from '../../../util/coachTier';

const AVATAR_COLORS = [
  '#e76f51', '#2a9d8f', '#e9c46a', '#264653', '#f4a261',
  '#6d6875', '#b5838d', '#457b9d', '#1d3557', '#2b9348',
];

function getAvatarColor(name) {
  if (!name) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function getInitials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : name.slice(0, 2).toUpperCase();
}

function ListingCard(props) {
  const {
    imgUrl,
    name,
    desc,
    priceLabel,
    typeOfService,
    keywords,
    from,
    listingUuid,
    authorUrl,
    isPremium,
    user,
    authorName,
  } = props;

  const pushServiceFilter = service => {
    props.history.push(`/s?pub_type-of-service=${service}`);
  };

  const formattedDesc = new DOMParser().parseFromString(
    new DOMParser().parseFromString(desc || '', 'text/html').documentElement.textContent,
    'text/html'
  ).documentElement.textContent;

  const formattedListingUrl = `/l/${strToSlug(name)}/${listingUuid}`;

  const serviceTagLine =
    typeOfService && typeOfService.length
      ? typeOfService.slice(0, 3).join(' · ').toUpperCase()
      : null;

  const priceParts = priceLabel ? priceLabel.split(' / ') : ['', ''];
  const priceAmount = priceParts[0] || '';
  const perType = priceParts[1] ? priceParts[1].toUpperCase() : '';

  const pubTier = readPublicBadgeTier(user);
  const isVerifiedForPublic = pubTier && pubTier !== TIERS.NETWORK_MEMBER;

  const avatarColor = getAvatarColor(authorName);
  const initials = getInitials(authorName);

  return (
    <div
      className={classNames(
        css.base,
        isVerifiedForPublic ? css.verified : '',
        isPremium ? css.premium : ''
      )}
    >
      {/* image */}
      <Link to={formattedListingUrl} className={css.imageBase}>
        <img alt="Listing" className={css.img} src={imgUrl} />
        {isVerifiedForPublic && (
          <div className={css.verifiedBadge}>
            <span className={css.verifiedBadgeCheck}>&#10003;</span>
            <span>VERIFIED</span>
          </div>
        )}
      </Link>

      {/* content */}
      <div className={css.contentBase}>
        {serviceTagLine && <p className={css.serviceTagLine}>{serviceTagLine}</p>}

        <Link className={css.title} to={formattedListingUrl}>
          {name}
        </Link>

        <Link style={{ textDecoration: 'none', color: 'inherit' }} to={authorUrl}>
          <div className={css.authorLine}>
            <span
              className={css.authorAvatar}
              style={{ backgroundColor: avatarColor }}
            >
              {initials}
            </span>
            <span className={css.authorBy}>By</span>
            <span className={css.authorName}>{authorName}</span>
            <VerificationBadge user={user} size="sm" />
            <TierBadge tier={pubTier} size="sm" />
          </div>
        </Link>

        <div className={css.description}>{formattedDesc}</div>

        <div className={css.tagRow}>
          {typeOfService &&
            typeOfService.slice(0, 5).map((service, index) => (
              <span
                key={'tag_' + index}
                className={css.tag}
                onClick={() => pushServiceFilter(service)}
              >
                {service}
              </span>
            ))}
        </div>
      </div>

      {/* price + actions */}
      <div className={css.actionBase}>
        {perType && <p className={css.perLabel}>{perType}</p>}
        <p className={css.priceAmount}>{priceAmount}</p>
        {from && from !== 'No location' && <p className={css.fromText}>{from}</p>}
        <Link className={css.bookBtn} to={formattedListingUrl}>
          Book now &rsaquo;
        </Link>
        <Link className={css.saveBtn} to={formattedListingUrl}>
          &#128276; Save
        </Link>
      </div>
    </div>
  );
}

export default withRouter(ListingCard);
